/** @jsx jsx */

import { MouseEvent } from 'react';

import { jsx } from '@emotion/core';
import {
  Alert,
  AlertDescription,
  Button,
  ButtonGroup,
} from '@zapier/design-system';

import Link from 'app/common/components/Link';

import VersioningHelpButton from './VersioningHelpButton';

type Props = {
  onEditClick: (event: MouseEvent) => void;
  openVersionHelp: (event: MouseEvent) => void;
  versionsLink: string;
};

/**
 * Once the user has successfully cloned the version
 * we render a success block
 */
const CtaCloneSuccess = ({
  onEditClick,
  openVersionHelp,
  versionsLink,
}: Props) => (
  <Alert
    status="success"
    title="Success! You’ve created a new cloned version for editing."
  >
    <AlertDescription>
      After you’re done making edits don’t forget to{' '}
      <Link href={versionsLink}>promote your version to public and</Link>{' '}
      <Link href={versionsLink}>migrate users</Link>
    </AlertDescription>
    <ButtonGroup columnSize="minmax(0, auto)" justify="start">
      <Button onClick={onEditClick}>Edit Integration</Button>
      <VersioningHelpButton onClick={openVersionHelp} />
    </ButtonGroup>
  </Alert>
);

export default CtaCloneSuccess;
